import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import globals from '@/plugins/globals'

export const locationStore = defineStore('location', {
  id: 'location',
  state: () => ({
    listParams: {
      page: 1,
      pageSize: 10,
      filterOptions: null,
      filterBy: null,
      sortBy: 'asc',
      orderBy: 'adasInspection',
      searchTerm: ''
    },
    loading: {
      inspections: false,
      inspection: false,
      repairLines: false
    },
    locations: [],
    location: null,
    locationsFound: [],
    foundLocations: [],
    preferences: []
  }),
  actions: {
    setListParam(data) {
      this.listParams[data.name] = data.value
    },
    initLocations() {
      this.locationsFound = []
    },
    resetPreferences() {
      this.preferences = []
    },
    updatePreference(data) {
      if (this.preferences.length === 0) {
        this.preferences = []
      }
      if (this.preferences !== undefined && this.preferences !== null) {
        let found = false
        if (this.preferences.length > 0) {
          for (let i = 0; i < this.preferences.length; i++) {
            if (this.preferences[i].name === data.name) {
              this.preferences[i].value = data.value
              this.preferences[i].changed = true
              found = true
              break
            }
          }
        }
        if (found === false) {
          data.changed = true
          this.preferences.push(data)
        }
      }
      console.log('Update Preference', this.preferences)
    },
    async getPreferences(data) {
      const r = await api.get('firm/firmPreference', data)
      if (Array.isArray(r)) {
        if (this.preferences.length > 0) {
          this.preferences = this.preferences.concat(r)
        } else {
          this.preferences = r
        }
      } else {
        if (globals.isObject(r) === true) {
          this.preferences.push(r)
        }
      }
      console.log('Got Preferences', this.preferences)
      return this.preferences
    },
    async savePreferences() {
      this.preferences.forEach((element) => {
        if (element.changed) {
          let data = {
            firm: element.firm,
            firmPreferenceName: element.name,
            preference: element.value,
            firmPreferenceCategory: element.type
          }
          api.post('firm/saveFirmPreference', data)
        }
      })
      if (this.preferences !== undefined && this.preferences !== null) {
        if (this.preferences.length > 0) {
          for (let i = 0; i < this.preferences.length; i++) {
            if (this.preferences[i] !== '') {
              this.preferences[i].changed = false
            }
          }
        }
      }
    },
    async getLocations(searchOptions) {
      const r = await api.get('firm/getFirms', searchOptions)
      this.locations = r.data
      return r.data
    },
    async getLocation(id) {
      const r = await api.get(`firm/firm?firm=${id}`)
      this.location = r.data
      return r.data
    },
    async searchLocations(search) {
      this.locationsFound = []
      if (search !== undefined && search !== null) {
        if (search.searchterm !== '') {
          let url = ''
          url = `firm/firmSearch/?firm=${search.firm}&searchterm=${search.searchterm}`
          this.locationsFound = await api.get(url)
        }
      }
      console.log('Locations Found', this.locationsFound)
      return this.locationsFound
    }
  }
})
